import { render, staticRenderFns } from "./FormRF07.vue?vue&type=template&id=b16f0870&scoped=true"
import script from "./FormRF07.vue?vue&type=script&lang=js"
export * from "./FormRF07.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f0870",
  null
  
)

export default component.exports